import { render, staticRenderFns } from "./GooglePay.vue?vue&type=template&id=9c8c8a66&scoped=true"
import script from "./GooglePay.vue?vue&type=script&lang=js"
export * from "./GooglePay.vue?vue&type=script&lang=js"
import style0 from "./GooglePay.vue?vue&type=style&index=0&id=9c8c8a66&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8c8a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c8c8a66')) {
      api.createRecord('9c8c8a66', component.options)
    } else {
      api.reload('9c8c8a66', component.options)
    }
    module.hot.accept("./GooglePay.vue?vue&type=template&id=9c8c8a66&scoped=true", function () {
      api.rerender('9c8c8a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Echo/component/GooglePay.vue"
export default component.exports